import moment from 'moment';
export default moment;

import af from 'locale/af';
import am_et from 'locale/am-et';
import ar_dz from 'locale/ar-dz';
import ar_kw from 'locale/ar-kw';
import ar_ly from 'locale/ar-ly';
import ar_ma from 'locale/ar-ma';
import ar_ps from 'locale/ar-ps';
import ar_sa from 'locale/ar-sa';
import ar_tn from 'locale/ar-tn';
import ar from 'locale/ar';
import az from 'locale/az';
import be from 'locale/be';
import bg from 'locale/bg';
import bm from 'locale/bm';
import bn_bd from 'locale/bn-bd';
import bn from 'locale/bn';
import bo from 'locale/bo';
import br from 'locale/br';
import bs from 'locale/bs';
import ca from 'locale/ca';
import cs from 'locale/cs';
import cv from 'locale/cv';
import cy from 'locale/cy';
import da from 'locale/da';
import de_at from 'locale/de-at';
import de_ch from 'locale/de-ch';
import de from 'locale/de';
import dv from 'locale/dv';
import el from 'locale/el';
import en_au from 'locale/en-au';
import en_ca from 'locale/en-ca';
import en_gb from 'locale/en-gb';
import en_ie from 'locale/en-ie';
import en_il from 'locale/en-il';
import en_in from 'locale/en-in';
import en_nz from 'locale/en-nz';
import en_sg from 'locale/en-sg';
import eo from 'locale/eo';
import es_do from 'locale/es-do';
import es_mx from 'locale/es-mx';
import es_us from 'locale/es-us';
import es from 'locale/es';
import et from 'locale/et';
import eu from 'locale/eu';
import fa from 'locale/fa';
import fi from 'locale/fi';
import fil from 'locale/fil';
import fo from 'locale/fo';
import fr_ca from 'locale/fr-ca';
import fr_ch from 'locale/fr-ch';
import fr from 'locale/fr';
import fy from 'locale/fy';
import ga from 'locale/ga';
import gd from 'locale/gd';
import gl from 'locale/gl';
import gom_deva from 'locale/gom-deva';
import gom_latn from 'locale/gom-latn';
import gu from 'locale/gu';
import he from 'locale/he';
import hi from 'locale/hi';
import hr from 'locale/hr';
import hu from 'locale/hu';
import hy_am from 'locale/hy-am';
import id from 'locale/id';
import is from 'locale/is';
import it_ch from 'locale/it-ch';
import it from 'locale/it';
import ja from 'locale/ja';
import jv from 'locale/jv';
import ka from 'locale/ka';
import kk from 'locale/kk';
import km from 'locale/km';
import kn from 'locale/kn';
import ko from 'locale/ko';
import ku_kmr from 'locale/ku-kmr';
import ku from 'locale/ku';
import ky from 'locale/ky';
import lb from 'locale/lb';
import lo from 'locale/lo';
import lt from 'locale/lt';
import lv from 'locale/lv';
import me from 'locale/me';
import mi from 'locale/mi';
import mk from 'locale/mk';
import ml from 'locale/ml';
import mn from 'locale/mn';
import mr from 'locale/mr';
import ms_my from 'locale/ms-my';
import ms from 'locale/ms';
import mt from 'locale/mt';
import my from 'locale/my';
import nb from 'locale/nb';
import ne from 'locale/ne';
import nl_be from 'locale/nl-be';
import nl from 'locale/nl';
import nn from 'locale/nn';
import oc_lnc from 'locale/oc-lnc';
import pa_in from 'locale/pa-in';
import pl from 'locale/pl';
import ps from 'locale/ps';
import pt_br from 'locale/pt-br';
import pt from 'locale/pt';
import ro from 'locale/ro';
import ru from 'locale/ru';
import sd from 'locale/sd';
import se from 'locale/se';
import si from 'locale/si';
import sk from 'locale/sk';
import sl from 'locale/sl';
import sq from 'locale/sq';
import sr_cyrl from 'locale/sr-cyrl';
import sr from 'locale/sr';
import ss from 'locale/ss';
import sv from 'locale/sv';
import sw from 'locale/sw';
import ta from 'locale/ta';
import te from 'locale/te';
import tet from 'locale/tet';
import tg from 'locale/tg';
import th from 'locale/th';
import tk from 'locale/tk';
import tl_ph from 'locale/tl-ph';
import tlh from 'locale/tlh';
import tr from 'locale/tr';
import tzl from 'locale/tzl';
import tzm_latn from 'locale/tzm-latn';
import tzm from 'locale/tzm';
import ug_cn from 'locale/ug-cn';
import uk from 'locale/uk';
import ur from 'locale/ur';
import uz_latn from 'locale/uz-latn';
import uz from 'locale/uz';
import vi from 'locale/vi';
import x_pseudo from 'locale/x-pseudo';
import yo from 'locale/yo';
import zh_cn from 'locale/zh-cn';
import zh_hk from 'locale/zh-hk';
import zh_mo from 'locale/zh-mo';
import zh_tw from 'locale/zh-tw';
moment.locale('en');
